<template>
  <div class="card_list relative" :class="noti ? 'scroll_unset' : ''">
    <div class="contents_title">
      <h3>
        {{ $t('menu.patient_list') }}
        <span v-if="!live" style="margin-left:0px;">
          &nbsp;|&nbsp;{{`${$t('planCheck.state.active')} :`}}
          <span style="margin-left:0px;color:#2a589f">{{ activeCnt }}</span>
          &nbsp;&nbsp;{{`${$t('planCheck.state.inActive')} :`}}
          <span style="margin-left:0px;color:#2a589f">{{ patientList.length - activeCnt}}</span>
          <span v-if="maxCnt !== 100000" style="float: right">
            &nbsp;{{`${$t('planCheck.state.max')} :`}}
            <span style="margin-left:0px;color:#2a589f">{{ maxCnt }}</span>
          </span>
        </span>
        &nbsp;|&nbsp;
        <div style="float: right; margin-top: 8px; margin-left: 8px;">
          <button
              class="listBtn"
              @click="(event)=>{handleDataTypeClick(event, false)}"
          >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.00629 11H9.99371C10.5472 11 11 10.5472 11 9.99371V4.00629C11 3.45283 10.5472 3 9.99371 3H4.00629C3.45283 3 3 3.45283 3 4.00629V9.99371C3 10.5472 3.45283 11 4.00629 11ZM8.98742 8.98742H5.01258V5.01258H8.98742V8.98742ZM14.0063 11H19.9937C20.5472 11 21 10.5472 21 9.99371V4.00629C21 3.45283 20.5472 3 19.9937 3H14.0063C13.4528 3 13 3.45283 13 4.00629V9.99371C13 10.5472 13.4528 11 14.0063 11ZM18.9874 8.98742H15.0126V5.01258H18.9874V8.98742ZM9.99371 21H4.00629C3.45283 21 3 20.5472 3 19.9937V14.0063C3 13.4528 3.45283 13 4.00629 13H9.99371C10.5472 13 11 13.4528 11 14.0063V19.9937C11 20.5472 10.5472 21 9.99371 21ZM5.01258 18.9874H8.98742V15.0126H5.01258V18.9874ZM14.0063 21H19.9937C20.5472 21 21 20.5472 21 19.9937V14.0063C21 13.4528 20.5472 13 19.9937 13H14.0063C13.4528 13 13 13.4528 13 14.0063V19.9937C13 20.5472 13.4528 21 14.0063 21ZM18.9874 18.9874H15.0126V15.0126H18.9874V18.9874Z"
                  :fill="!list ? '#2A589F' : '#3B3A39'"
              />
            </svg>
          </button>
        </div>
        <div style="float: right; margin-top: 8px;">
          <button
              class="listBtn"
              @click="(event)=>{handleDataTypeClick(event, true)}"
          >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5 8.4469H19C19.55 8.4469 20 8.00885 20 7.47345C20 6.93805 19.55 6.5 19 6.5H5C4.45 6.5 4 6.93805 4 7.47345C4 8.00885 4.45 8.4469 5 8.4469ZM19 11.0265H5C4.45 11.0265 4 11.4646 4 12C4 12.5354 4.45 12.9735 5 12.9735H19C19.55 12.9735 20 12.5354 20 12C20 11.4646 19.56 11.0265 19 11.0265ZM5 15.5531H19C19.56 15.5531 20 15.9911 20 16.5265C20 17.0619 19.55 17.5 19 17.5H5C4.45 17.5 4 17.0619 4 16.5265C4 15.9911 4.45 15.5531 5 15.5531Z"
                  :fill="list ? '#2A589F' : '#3B3A39'"
              />
            </svg>
          </button>
        </div>
      </h3>
      <div class="title_right">
        <div v-if="!live" class="select">
          <v-select
              style="width: 150px;height: 44px;"
              v-model="status"
              :options="[
                  {
                    no: 'all',
                    trans: 'planCheck.state.all',
                  },
                  {
                    no: 'active',
                    trans: 'planCheck.state.active',
                  },
                  {
                    no: 'inactive',
                    trans: 'planCheck.state.inActive',
                  },
                ]"
              :get-option-label="option => $t(option.trans)"
              append-to-body
              :calculate-position="withPopper"
          >
            <template #search="{ attributes, events }">
              <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                  readonly="true"
              />
            </template>
            <span slot="no-options">
              {{ $t('patients.no_search_data') }}
            </span>
          </v-select>
          <div class="select__arrow"/>
        </div>
        &nbsp;
        <div class="select">
          <v-select
              style="width: 150px;height: 44px;"
              v-model="brainLesionStatus"
              :options="[
                  {
                    no: 99,
                    trans: 'patient.condition.brain_lesions',
                  },
                  ...brainLesionRange
                  ]"
              :get-option-label="option => $t(option.trans)"
              append-to-body
              :calculate-position="withPopper"
          >
            <template #search="{ attributes, events }">
              <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                  readonly="true"
              />
            </template>
            <span slot="no-options">
              {{ $t('patients.no_search_data') }}
            </span>
          </v-select>
          <div class="select__arrow"/>
        </div>
        &nbsp; | &nbsp;
        <a
            class="patient_add pointer no-drag"
            style="display: inline-block;color: var(--blue70);font-size: 13px;font-weight: 700;margin-top: 10px;margin-right:5px;padding: 10px;border: 2px var(--blue70) solid;border-radius:5px;"
            @click="handleAddClick"
        >
          <img src="@/assets/images/svg/icon_addpatient_schedule.svg" width="18" height="17" style="margin-right:0;" alt=""/>
          &nbsp;&nbsp;{{ $t('RMC.add') }}
        </a>
        <a
            class="patient_add pointer no-drag"
            :class="this.onOff? 'hidden' : ''"
            @click="$modal.show('patient-append-modal')"
            style="padding: 10px;border: 2px var(--blue70) solid;border-radius:5px;"
        >
          <img src="../../../../assets/images/member.png" alt="member">
          {{ $t('patients.add.btn') }}
        </a>
      </div>
    </div>
    <div v-if="!list">
      <ul
          class="patient_list"
          v-if="sortedPatientList.length > 0"
          ref="patientListUl"
      >
        <li
            v-for="item in sortedPatientList" :key="item.seqPatient"
            class="pointer patient_list_li"
            :class="isChecked(item.seqPatient)? 'blue_border' : ''"
            @click="clickUser(item.seqPatient)"
        >
          <div class="patient_list_head">
            <div class="list_patient_info">
              <p
                  :class="live || scheduleList === undefined ? '' : scheduleList.includes(item.patientInfo.seqMedicalRelation) ? 'min' : 'max'"
                  :title="item.patientInfo.patientInfoName"
              >
                {{ item.patientInfo.patientInfoName }}
              </p>
              <!-- <span
                  v-if="live"
                  style="float: right;position: absolute;top: 30px;right: 20px;"
              /> -->
              <span
                  v-if="scheduleList === undefined"
                  style="float: right;position: absolute;top: 30px;right: 20px;"
              />
              <span
                  v-else-if="!scheduleList.includes(item.patientInfo.seqMedicalRelation)"
                  class="edit_mode_btn"
                  style="float: right;position: absolute;top: 30px;right: 20px;"
                  @click="(event)=>{
                      handleClick(event, item.patientInfo.seqMedicalRelation, !item.check)
                    }"
              >
                <label class="patient_add pointer edit_patient_checkbox">
                  <input
                      type="checkbox"
                      :id="`checkbox-${item.seqPatient}`"
                      v-model="item.check"
                  >
                  <label :for="`checkbox-${item.seqPatient}`">
                    <span></span>
                  </label>
                </label>
              </span>
              <div
                  v-else
                  style="
                    float: right;
                    position: absolute;
                    top: 25px;
                    right: 20px;
                    background-color: #2a589f;
                    color: #FFFFFF;
                    height: 25px;
                    border-radius: 50px;
                    vertical-align: middle;
                    font-size: 12px;
                    padding: 5px;
                    font-weight: bold;
                  "
              >
                {{$t('planCheck.state.reservedPatient')}}
              </div>
              <span :style="`line-height:1.5; opacity: ${item.check ? 1.0 : 0.2}`">{{ item.patientEmail }}</span>
            </div>
          </div>
          <dl
              class="patient_sub_info"
              :style="`opacity: ${item.check ? 1.0 : 0.2}`"
          >
            <dt>{{ $t('patient.info.gender.key') }}</dt>
            <dd>{{ computedGender(item.patientInfo.patientInfoGender) }}</dd>
            <dt>{{ $t('patient.info.date_of_birth') }}</dt>
            <dd>{{
                item.patientInfo.patientInfoBirth ?
                    moment(item.patientInfo.patientInfoBirth).locale($t('country')).format('ll') : '-'
              }}
            </dd>
            <dt>{{ $t('patient.condition.on_set_date') }}</dt>
            <dd>{{
                item.patientInfo.patientInfoOccurrenceDate ?
                    moment(item.patientInfo.patientInfoOccurrenceDate).locale($t('country')).format('ll') : '-'
              }}
            </dd>
            <dt>{{ $t('patient.condition.brain_lesions') }}</dt>
            <dd>
              {{ item.patientInfo.patientInfoBrainLesionTitle}}
            </dd>
            <dt>S.D</dt>
            <dd>{{
                item.patientInfo.patientInfoOccurrenceDate ? moment().diff(
                    item.patientInfo.patientInfoOccurrenceDate, "days") + $t('unit.days') : '-'
              }}
            </dd>
            <dt>mRS</dt>
            <dd>
              {{ item.patientStatus.patientStatusMRS === null || item.patientStatus.patientStatusMRS === "" ? 'N/A' : item.patientStatus.patientStatusMRS }}
            </dd>
          </dl>
        </li>
      </ul>
      <PatientListNoData
          v-else
          class="patient_list no_data"
          :title="loading ? $t('table.list.loading') : $t('patients.no_patients')"
      />
    </div>
    <div v-else>
      <ListTable
          class="patient_list"
          v-if="sortedPatientList.length > 0"
          :data="sortedPatientList"
      >
      </ListTable>
      <PatientListNoData
          class="patient_list no_data"
          :title="loading ? $t('table.list.loading') : $t('patients.no_patients')"
      />
    </div>
    <ScheduleEditModal
        @getMySchedule="getMySchedule"
    />
    <NotificationModal @hideNoti="hideNoti" @showNoti="showNoti"/>
  </div>
</template>

<script>
import _API from '../../../../api';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import PatientListNoData from './noItem';
import ListTable from './listTable';
import {GENDER_TRANS} from "@/enum/lib";
import ScheduleEditModal from '../../../modal/scheduleCalendar/scheduleEdit';
import {
  _BRAIN_LESION_RANGE,
} from "@/components/Table/static";
import { createPopper } from '@popperjs/core'

export default {
  data() {
    return {
      noti: false,
      patientList: [],
      scheduleList: undefined,
      sortedPatientList: [],
      onOff: false,
      allChecked: false,
      checkedArr: [],
      activeCnt: 0,
      maxCnt: this.getLatestPurchaseInfo().paymentInfo.productPatientProfileLimit,
      list: true,
      // TODO: 운영 반영시 제거
      live: process.env.VUE_APP_MODE === 'LIVE',
      loading: false,
      brainLesionRange: this.getCheckTimeZone() ? [
          ..._BRAIN_LESION_RANGE.filter(item => item.no <= 0 || item.no >= 7),
          ..._BRAIN_LESION_RANGE.slice(1,7),
      ] : _BRAIN_LESION_RANGE,
      brainLesionStatus: {
        no: 99,
        trans: 'patient.condition.brain_lesions',
      },
      status: {
        no: 'all',
        trans: 'planCheck.state.all',
      },
    }
  },
  components: {
    ScheduleEditModal,
    PatientListNoData,
    ListTable,
    NotificationModal: () => import('@/components/modal/notification'),
  },
  methods: {
    ...mapActions(['inspectSelectPatient', 'initPatientList', 'changeNavMenu', 'refreshScheduleForToday']),
    ...mapGetters(['getPatientList', 'getLatestPurchaseInfo', 'getCheckTimeZone']),
    ...mapMutations(['initPatientList']),
    clickUser(seqPatient) {
      this.inspectSelectPatient(seqPatient);
      this.$router.push(`/patientList/details/home?id=${seqPatient}`);
    },
    drawPatientList() { //환자 목록을 그린다.
      // if (!this.live) {
        const param = {
          startDatetime: this.moment.tz(this.moment(new Date()).format('YYYY-MM-DD'), this._TIME_ZONE).format(),
          endDatetime: this.moment.tz(this.moment(new Date().addDays(3650)).format('YYYY-MM-DD'), this._TIME_ZONE).add({h: 24}).format()
        };

        _API.SCHEDULE.getAllScheduleByRangeForClinic(param)
            .then(({data}) => {

              this.patientList = this.patientData(this.getPatientList());
              this.scheduleList = data.scheduleList
                  .filter(item => item.scheduleStatus === 0)
                  .map(item => item.seqMedicalRelation);
            })
      // }
    },
    getPatientListForMountStatus(refresh = false) { //마운트상태에서 환자목록을 조회한다.
      const patients = this.getPatientList();//vuex에서 먼저 조회를 하며
      if (refresh || !patients || patients.length === 0) { //vuex에서 없는 경우
        this.fetchGetPatientList()
            .then(() => {
              this.drawPatientList();
            })
      } else {
        this.drawPatientList();
      }
    },
    fetchGetPatientList: function () {
      return new Promise((resolve, reject) => {
        this.loading = true;
        _API.PATIENT_LIST.getMyPatientsAndReservedSchedulesForToday()
            .then(res => {
              if (res.data.isSuccess && res.data.failedCode === '0') {
                try {
                  this.$store.dispatch(`initPatientList`, {
                    patientList: res.data.patientList,
                  }).then(_ => {
                    this.patientList = this.patientData(res.data.patientList);
                    resolve();
                  })
                } catch (e) {
                  reject(`[getPatientsAndSchedules]${e}`);
                }
              } else {
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.unexpected_error'
                });
                resolve();
              }
            })
            .catch(e => reject(`[getPatientsAndSchedules]${e}`))
            .finally(() => {
              this.loading = false;
            })
      })
    },
    // 체크 상태를 확인해 파란색 보더를 그릴지 말지 결정하는 코드
    isChecked(seqPatient) {
      for (let checkedValue of this.checkedArr) {
        if (seqPatient === checkedValue)
          return true;
      }
    },
    hideNoti() {
      this.noti = false;
    },
    showNoti() {
      this.noti = true;
    },
    handleClick(event, seqMedicalRelation, isEnabled) {
      event?.stopPropagation();
      event?.preventDefault();

      const activeCnt = this.patientList.filter(item => item.check === true).length;

      if (isEnabled && activeCnt >= this.maxCnt) {
        this.$modal.show('patient-append-modal')
      } else {
        let tempSortedPatientList = JSON.parse(JSON.stringify(this.sortedPatientList));
        this.sortedPatientList = tempSortedPatientList.map((item) => {
          return {
            ...item,
            check: seqMedicalRelation === item.patientInfo.seqMedicalRelation ? !item.check : item.check,
          }
        })

        _API.PATIENT.changeActivationStatus(seqMedicalRelation, isEnabled);
        setTimeout(() => {
          let tempPatientList = JSON.parse(JSON.stringify(this.patientList));
          this.$store.dispatch(`initPatientList`, {
            patientList: tempPatientList.map((item) => {
              return seqMedicalRelation === item.patientInfo.seqMedicalRelation ? {
                ...item,
                check: !item.check,
              } : item
            }),
          })
        }, this.status.no !== 'all' ? 500 : 0)
      }
    },
    handleDataTypeClick(_event, value) {
      this.list = value;
    },
    handleAddClick() {
      this.$modal.show('schedule-edit-modal', 'write');
    },
    getMySchedule() {
      this.refreshScheduleForToday(true);
    },
    patientData(data) {
      return data.map((item) => {
        return {
          ...item,
          patientInfo: {
            ...item?.patientInfo,
            patientInfoBrainLesionTitle: this.$t(_BRAIN_LESION_RANGE[item.patientInfo.patientInfoBrainLesion]?.trans),
          },
        }
      })
    },
    withPopper(dropdownList, component, {width}) {
      dropdownList.style.width = width
      const popper = createPopper(component.$refs.toggle, dropdownList, {})

      return () => popper.destroy()
    },
  },
  mounted() {
    this.getPatientListForMountStatus();

    this.$store.dispatch('changeNavMenu', 0);
    this.$store.dispatch('changeMainMenu', 1); // patient list
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (this.patientList !== state.patientList)
        this.patientList = this.patientData(state.patientList);

      if (mutation.type === 'refreshScheduleForToday' && mutation.payload) {
        if (state.mainMenu === 1) {
          this.getPatientListForMountStatus(true);
          this.refreshScheduleForToday(false);
        }
      }

      if (mutation.type === 'setLatestPurchaseInfo')
        this.maxCnt = mutation.payload.paymentInfo.productPatientProfileLimit;
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  computed: {
    displayPatientList() {
      return this.sortedPatientList;
    },
    computedGender() {
      return (patientInfoGender) => {
        return patientInfoGender ? this.$t(GENDER_TRANS[patientInfoGender].trans) : this.$t(GENDER_TRANS[null].trans)
      }
    }
  },
  watch: {
    // onOff(newVal) {
    //   // 편집모드를 종료할 경우 초기화 하는 곳, 모든 체크 박스, 블루 보더를 없애야함.
    //   if (!newVal) {
    //     this.checkedArr = [];
    //     this.allChecked = false;
    //     let inputChecked = document.querySelectorAll('.input_checked');
    //     for (let i = 0; inputChecked.length > i; i++) {
    //       inputChecked[i].checked = false;
    //     }
    //     let liElement = document.querySelectorAll('.patient_list_li');
    //     for (let i = 0; liElement.length > i; i++) {
    //       liElement[i].classList.remove('blue_border');
    //     }
    //   }
    // },
    status(value, _oldValue) {
      const check = value.no === 'active';
      this.sortedPatientList = this.patientList.filter(item => (value.no === 'all' || item.check === check) && (this.brainLesionStatus.no === 99 || item.patientInfo.patientInfoBrainLesion === this.brainLesionStatus.no))
    },
    brainLesionStatus(value, _oldValue) {
      const check = this.status.no === 'active';
      this.sortedPatientList = this.patientList.filter(item => (this.status.no === 'all' || item.check === check) && (value.no === 99 || item.patientInfo.patientInfoBrainLesion === value.no))
    },
    patientList(value) {
      const check = this.status.no === 'active';
      this.sortedPatientList = value.filter(item => (this.status.no === 'all' || item.check === check) && (this.brainLesionStatus.no === 99 || item.patientInfo.patientInfoBrainLesion === this.brainLesionStatus.no))
      this.activeCnt = value.filter(item => item.check === true).length;
    },
  }
}
</script>
<style lang="scss">
@import "@/scss/default";

.blue_border {
  border: 2px solid var(--blue70) !important;
}

.patient_list {
  overflow-y: auto;
  height: calc(var(--app-height) - 240px);
}

.patient_list li {
  padding: 20px 20px 25px 20px;
  float: left;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  background: #fff;
  border: 4px solid #fff;
  position: relative;
  margin: 10px;
  width: 348px;

  //@media screen and (max-width: 1024px) {
  //  width: 245px;
  //}
}

.patient_list li .patient_list_head {
  overflow: hidden;
}

.patient_list li .patient_list_head .list_photo_frame {
  width: 50px;
  height: 50px;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  float: left;
  margin-right: 12px;
}

.patient_list li .patient_list_head .list_photo_frame .photo_wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transform: translate(50%, 50%);
  -ms-transform: translate(50%, 50%);
  transform: translate(50%, 50%);
}

.patient_list li .patient_list_head .list_photo_frame .photo_wrap img {
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  min-width: 100%;
  min-height: 100%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.patient_list li .patient_list_head .list_patient_info {
  text-align: left;
  float: left;
  color: var(--grey70);
  font-size: 12px;

  .min {
    max-width: 200px;
  }

  .max {
    max-width: 240px;
  }
}

.patient_list li .patient_list_head .list_patient_info p {
  text-align: left;
  font-weight: bold;
  color: var(--grey100);
  margin: 5px 0 10px 0;
  font-size: 18px;
  height: 53px;
  line-height: 1.5;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;

  width: 300px;
  //@media screen and (max-width: 1024px) {
  //  width: 245px;
  //}
}

.patient_list li .patient_list_head .i_camera {
  float: right;
}

.patient_list li table {
  width: 100%;
  margin-top: 25px;
}

.patient_list li table th {
  width: 60px;
  font-size: 13px;
  text-align: left;
  padding: 7px 0;
}

.patient_list li table td {
  font-size: 13px;
  padding: 7px 0;
}

.patient_list li:hover {
  border: 4px solid #2A589F;
}

.patient_sub_info {
  overflow: hidden;
}

.patient_sub_info dt {
  width: 150px;
  float: left;
  height: 30px;
  color: var(--grey90);
  font-size: 12px;
  font-weight: bold;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
}

.patient_sub_info dd {
  width: calc(100% - 150px);
  float: left;
  height: 30px;
  font-size: 12px;
  text-indent: 15px;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.i_camera {
  margin: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  padding: 13px;
  border-radius: 50px;
}

.delete-patient-checkbox {
  display: block;
  float: right;
  margin-right: -8px;
  margin-top: 2px;
}

.edit_patient_checkbox {
  padding-right: 58px;

  input[type="checkbox"]:checked + label span {
    width: 0px;
    height: 0px;
    background: none;
    z-index: 0;
  }

  input[type="checkbox"] + label span {
    display: inline-block;
    width: 0px;
    height: 0px;
    margin: 0;
    vertical-align: middle;
    background: none;
  }

  input[type="checkbox"] {
    position: absolute;
    visibility: hidden;
  }

  label {
    display: block;
    position: absolute;
    width: 52px;
    height: 25px;
    border-radius: 50px;
    background-color: var(--grey30);
    transition-duration: 0.2s;
    margin-top: -5px;
    margin-left: 9px;
  }

  label span {
    position: absolute;
    left: 3px;
    top: 3px;
    z-index: 1;
    width: 19px !important;
    height: 19px !important;
    border-radius: 50%;
    background-color: var(--white) !important;
    transition-duration: 0.2s;
  }

  label:before,
  label:after {
    position: absolute;
    top: 0;
    width: 30px;
    font-size: 8px;
    line-height: 25px;
    color: var(--white);
    text-align: center;
  }

  label:before {
    left: -2px;
    content: 'ON';
  }

  label:after {
    right: 0;
    content: 'OFF';
  }

  input:checked + label {
    background-color: var(--blue70);
  }

  input:checked + label span {
    /* left: 29px; */
    transform: translateX(26px);
  }
}

.select {
  position: relative;
  display: inline-block;

  select {
    display: inline-block;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  select::-ms-expand {
    display: none;
  }

  .select__arrow {
    position: absolute;
    top: 16px;
    right: 15px;
    width: 0;
    height: 0;
    pointer-events: none;
    border-style: solid;
    border-width: 8px 5px 0 5px;
    border-color: #605e5c transparent transparent transparent;
  }
}

.listBtn {
  border-width: 0;
  background-color: unset;
  padding: 0;
  cursor: pointer;
  width: 24px;
  height: 24px;

  svg {
    display: block;
    margin: auto;
  }
}
</style>

